import styled from 'styled-components';
export const FooterSocialIconsContainer = styled.div `
  display: flex;
  align-items: center;
  flex-wrap: wrap;
`;
export const IconLink = styled.a `
  margin-bottom: 7px;
  padding-right: 5px;

  &:last-child {
    padding-right: 0;
  }
`;
//# sourceMappingURL=FooterSocial.styled.js.map